import KkRoot from "components/KkRoot";
import xamatron from "xamatron";
xamatron.ready(function () {
    new KkRoot().$mount("#root");
});



//////////////////
// WEBPACK FOOTER
// ./app/ts/main.ts
// module id = 27
// module chunks = 0